export default __webpack_public_path__ + "static/media/client7.5ac7909e.png";